import React from 'react';
import { DropdownMenu } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/components/DropdownMenu';
import PortfolioBuilderStore, {
  adStrategies
} from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/PortfolioBuilder/stores';
import { styled } from '@mui/system';

export const OptimizationDropdown = () => {
  const { selectedOptimizationId, setSelectedOptimizationId } = PortfolioBuilderStore((s) => ({
    setSelectedOptimizationId: s.setSelectedOptimizationId,
    selectedOptimizationId: s.selectedOptimizationId
  }));

  const StyledDiv = styled('div')({
    '& .MuiTypography-root': {
      fontWeight: 400,
      fontiSize: '14px'
    }
  });

  return (
    <StyledDiv style={{ width: 'fit-content', marginBottom: '24px' }}>
      <DropdownMenu
        options={adStrategies}
        selectedId={selectedOptimizationId}
        onChange={(strategy) => {
          setSelectedOptimizationId(strategy.id);
        }}
      />
    </StyledDiv>
  );
};
